export default {
  ['LOGIN'](state, user) {
    state.user = user.data;
  }
};
